import React, { useState, lazy, Suspense } from "react";
import { Container, Navbar, NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import logo from "../../assets/svg/logo3.svg";
import "./style.css";
import Loading from "../../components/loading/index.jsx";
const ProfileModal = lazy(() =>
  import("../../components/profileModal/index.jsx")
);

export default function HeaderMembro() {
  const { user, logout } = useAuth();
  const [showModal, setShowModal] = useState(false);

  return (
    <header className="header-membro shadow-sm fixed-top">
      <Navbar expand="lg" className="bg-white py-2">
        <Container>
          <div className="header-membro-grid w-100 d-flex align-items-center justify-content-between">
            {/* Coluna esquerda */}
            <div className="header-left d-flex align-items-center">
              <Navbar.Brand as={Link} to="/home">
                <img src={logo} alt="Logo" height="45" />
              </Navbar.Brand>
            </div>

            {/* Coluna direita */}
            <div className="header-right d-flex align-items-center gap-3">
              <NavDropdown
                title={
                  <span className="user-dropdown-title">
                    <i className="bi bi-person-circle"></i>
                    <span className="user-name-text">
                      {user?.nickname || "Usuário"}
                    </span>
                    <i className="bi bi-caret-down-fill"></i>
                  </span>
                }
                align="end"
                className="custom-user-dropdown"
              >
                <NavDropdown.Item
                  as={Link}
                  to="/welcome"
                  style={{
                    fontWeight: 500,
                    color: "#0d6efd",
                  }}
                >
                  <i
                    className="bi bi-globe2"
                    style={{ marginRight: "8px" }}
                  ></i>
                  Site Público
                </NavDropdown.Item>
                <NavDropdown.Item
                  onClick={() => setShowModal(true)}
                  style={{
                    fontWeight: 500,
                    color: "#0d6efd",
                  }}
                >
                  <i
                    class="bi bi-person-fill-gear"
                    style={{ marginRight: "8px" }}
                  ></i>
                  Meu Perfil
                </NavDropdown.Item>
                <NavDropdown.Item
                  onClick={logout}
                  style={{
                    fontWeight: 500,
                    color: "#dc3545",
                  }}
                >
                  <i
                    className="bi bi-box-arrow-right"
                    style={{ marginRight: "8px" }}
                  ></i>
                  Sair
                </NavDropdown.Item>
              </NavDropdown>
            </div>
            <Suspense fallback={<Loading />}>
              {showModal && (
                <ProfileModal
                  show={showModal}
                  onClose={() => setShowModal(false)}
                />
              )}
            </Suspense>
          </div>
        </Container>
      </Navbar>
    </header>
  );
}
